export const IsEmptyStr = (str: any) => {
  return !str || str === "";
}

export const IsEmptyStrWithTrim = (str: any) => {
  return !str || str.trim() === "";
}

export const IsValidEmailAddress = (address: any) => {
  return !!address && /\S+@\S+\.\S+/.test(address);
}

export const IsZero = (str: any) => {
  return !str || +str == 0;
}

export const IsNumeric = (str: any) => {
  return str && /^\d+(\.\d+)?$/.test(str);
}

export const isQuillEmpty = (content: string) => {
  return !content || content.replace(/<(.|\n)*?>/g, '').trim().length === 0 || content === '<p><br></p>';
};

export const IsNullOrUndefined = (target: any) => {
  return target === null || target === undefined;
}

export const SanitizeString = (str: string) => {
  if (!str) return "";
  return str
    // Remove null chars + control chars
    .replace(/[\u0000-\u001F\u007F-\u009F]/g, '')
    // Optional: trim extra whitespace
    .trim();
}